import { render, staticRenderFns } from "./TheAsideRight.vue?vue&type=template&id=c3561ee4&scoped=true&"
import script from "./TheAsideRight.vue?vue&type=script&lang=js&"
export * from "./TheAsideRight.vue?vue&type=script&lang=js&"
import style0 from "./TheAsideRight.vue?vue&type=style&index=0&id=c3561ee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3561ee4",
  null
  
)

export default component.exports